import React from "react";

export const SEOUtil: React.FC<{ name: string, url: string, description: string, mainEntityOfPage?: boolean, sameAs?: string[], hasPart?: { url: string, name: string }[], page?: boolean }> = ({ name, url, description, mainEntityOfPage, sameAs, hasPart, page }) => {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": page ? "WebPage": "WebSite",
                    "name": name,
                    "url": "https://szkolnyprzewodnik.edu.pl" + url,
                    "mainEntityOfPage": mainEntityOfPage ? "https://szkolnyprzewodnik.edu.pl" + url : undefined,
                    "description": description,
                    "sameAs": sameAs,
                    "author": {
                        "@type": "Person",
                        "name": "Szkolny Przewodnik"
                    },
                    "image": {
                        "@type": "ImageObject",
                        "url": "https://szkolnyprzewodnik.edu.pl/thumbnail.png",
                        "width": 1201,
                        "height": 631
                    },
                    "hasPart": hasPart
                })
            }}
        />
    )
}